/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityCveDetail {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityCveDetail.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityCveDetail>): AppSecopsVulnerabilityCveDetail {
        let obj = Object.assign(new AppSecopsVulnerabilityCveDetail(), model);
        AppSecopsVulnerabilityCveDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityCveDetail>): AppSecopsVulnerabilityCveDetail {
        if (!model) return null;
        return AppSecopsVulnerabilityCveDetail.newInstance(<AppSecopsVulnerabilityCveDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityCveDetail) {
        if (!obj) return;

        models.AppSecopsVulnerabilityCveDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityCveDetail): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityCveDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * ID of the vulnerability.
     */
    id: string;

    /**
     * Type of the vulnerability.
     */
    type: string;

}
